import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { chatApi as n } from "@maat/api-chat";
//#region src/hooks/useConversationByBookingQuery.ts
var r = (r, i = {}) => t({
	queryKey: e.byBooking(r),
	queryFn: () => n.lookupConversationByBooking(r),
	enabled: !!r && (i.enabled ?? !0)
});
//#endregion
export { r as useConversationByBookingQuery };
